import { NavLink, Outlet } from "react-router-dom";
import { CalendarPlus, CalendarCheck, UserRound, Clock, LayoutDashboard } from "lucide-react";
import { Logo, LangToggle, ThemeToggle } from "@/components/atlas/Shared";
import { HelpMenu } from "@/components/atlas/HelpMenu";
import { NotificationBell } from "@/components/atlas/NotificationBell";
import { useLang } from "@/lib/i18n";
import { useAuth } from "@/lib/auth";

const TABS = [
  ["/app", "nav.availableShort", "nav.available", CalendarPlus, true],
  ["/app/schedule", "nav.schedule", "nav.schedule", CalendarCheck],
  ["/app/hours", "nav.hoursShort", "nav.hours", Clock],
  ["/app/profile", "nav.profile", "nav.profile", UserRound],
];

export default function EmployeeLayout() {
  const { t } = useLang();
  const { user } = useAuth();
  const tabs = user.role === "admin" ? [...TABS, ["/admin", "nav.admin", "nav.admin", LayoutDashboard, true]] : TABS;
  return (
    <div className="min-h-screen pb-28 md:pb-10">
      <header className="dark-zone sticky top-0 z-20 bg-[#0B0B0C]/85 backdrop-blur-md border-b border-white/[0.05]">
        <div className="max-w-3xl mx-auto flex items-center justify-between px-5 h-16">
          <Logo light />
          <div className="flex items-center gap-1.5 sm:gap-2">
            <LangToggle light />
            <ThemeToggle />
            <HelpMenu />
            <NotificationBell light />
          </div>
        </div>
        <nav className="hidden md:flex max-w-3xl mx-auto px-5 pb-3 gap-2">
          {tabs.map(([to, , label, , end]) => (
            <NavLink key={to} to={to} end={end} data-testid={`tab-${to.split("/").pop()}`}
              className={({ isActive }) => `press rounded-full px-4 py-1.5 text-sm ${isActive ? "bg-[#C5A059] text-[#0A0A0C] font-semibold" : "text-white/55 hover:text-white bg-white/[0.04]"}`}>
              {t(label)}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-8">
        <Outlet />
      </main>
      <nav className={`md:hidden fixed bottom-4 inset-x-4 z-30 rounded-full bg-[#161618]/95 backdrop-blur-md border border-white/[0.08] shadow-[0_20px_40px_-10px_rgba(0,0,0,0.9)] grid ${tabs.length > 4 ? "grid-cols-5" : "grid-cols-4"} p-1.5`}>
        {tabs.map(([to, short, , Icon, end]) => (
          <NavLink key={to} to={to} end={end} data-testid={`bottom-tab-${to.split("/").pop()}`}
            className={({ isActive }) => `press rounded-full flex flex-col items-center gap-0.5 py-2 text-[10px] font-medium ${isActive ? "bg-[#C5A059]/15 text-[#D9B872]" : "text-neutral-500"}`}>
            <Icon className="w-5 h-5" strokeWidth={1.5} />
            {t(short)}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
